import styled from "styled-components";

export const NewVariationWrap = styled.div`
.heading{
  margin-bottom: 10px;
}
.user-fields {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  margin-bottom: 20px;
  border-bottom: 1px solid #ECECEC;
  @media (min-width: 768px) {
      gap: 20px;
      grid-template-columns: repeat(2, 1fr);
    }
    .offers {
      .variations {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 15px;
        margin-bottom: 5px;
        button {
          background-color: transparent;
          border: 1px solid #cdcdcd;
          color: var(--black);
        }
      }
      .btn-wrap {
        button {
          width: 100%;
          background-color: #cdcdcd;
          color: var(--white);
        }
      }
    }
  }
  .delete-btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px;
  }
  .sub-variation-btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px;
    font-size: 14px;
    color: var(--primary);
    cursor: pointer;
  }
  .btn-holder {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    @media (min-width: 575px) {
      flex-direction: row;
    }
    .add-btn,
    .save-btn {
      width: 100%;
      button {
        width: 100%;
      }
    }
  }
`;
